import Vue from 'vue'
import VueRouter from 'vue-router'
import { generateUserId } from '@/assets/js/utils.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/desktop'
  },
  {
    path: '/desktop',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/SoftwareCenter',
    name: 'SoftwareCenter',
    component: () => import('../views/SoftwareCenter.vue'),
  },
  {
    path: '/ConversionTool',
    name: 'ConversionTool',
    component: () => import('../views/ConversionTool.vue'),
  },
  {
    path: '/FeedbackView',
    name: 'FeedbackView',
    component: () => import('../views/FeedbackView.vue'),
  },
  {
    path: '/DownloadManager',
    name: 'DownloadManager',
    component: () => import('../views/DownloadManager.vue'),
  },
  {
    path: '/MapTool',
    name: 'MapTool',
    component: () => import('../views/download/MapTool.vue'),
  },
  {
    path: '/TerrainTool',
    name: 'TerrainTool',
    component: () => import('../views/download/TerrainTool.vue'),
  },{
    path: '/MessageManger',
    name: 'MessageManger',
    component: () => import('../views/MessageManger.vue'),
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// 路由守卫：确保应用启动时初始化 userId
router.beforeEach((to, from, next) => {
  // 如果 URL 中有 userId，存储到 localStorage
  if (to.query.userId) {
    localStorage.setItem('mzw_user_id', to.query.userId);
  } else {
    // 如果 URL 中没有 userId，且 localStorage 中也没有，则生成一个
    if (!localStorage.getItem('mzw_user_id')) {
      const newUserId = generateUserId();
      localStorage.setItem('mzw_user_id', newUserId);
    }
  }
  next();
})

export default router
